import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=3ed53737&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed53737')) {
      api.createRecord('3ed53737', component.options)
    } else {
      api.reload('3ed53737', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=3ed53737&", function () {
      api.rerender('3ed53737', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/ChangePassword.vue"
export default component.exports